import ParticipantHistory from "../components/Profile/ParticipantProfile/History";

const History = () => {
  return <ParticipantHistory />;
};

export default History;
